import ExcelJS from 'exceljs';
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import CustomTable from '../../components/Table';
import SettlementController, {
  KnockStoreSettleDetailType,
  KnockStoreSettleType,
} from '../../controller/SettlementController';
import 'moment/locale/ko';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

type TotalType = {
  store_discount_amt: number;
  com_discount_amt: number;
  order_amount: number;
  delivery_price: number;
  final_payment_amt: number;
  payment_fee: number;
  relay_fee: number;
  room_tip: number;
  vat: number;
  total_deductions: number;
  cancel_amt: number;
  normal_count: number;
  cancel_count: number;
  foreign_card_count: number;
  foreign_card_amount: number;
  domestic_card_count: number;
  domestic_card_amount: number;
  total_amount: number;
};

const KnockStoreOrderSettle = () => {
  const navigate = useNavigate();
  const [year, setYear] = useState<number>(new Date().getFullYear());
  const [month, setMonth] = useState<number>(new Date().getMonth() + 1);

  const [visibleMonthSelect, setVisibleMonthSelect] = useState<boolean>(false);

  const [card, setCard] = useState<{ card_name: string; count: number }[]>([]);

  const [total, setTotal] = useState<TotalType>({
    store_discount_amt: 0,
    com_discount_amt: 0,
    order_amount: 0,
    delivery_price: 0,
    final_payment_amt: 0,
    payment_fee: 0,
    relay_fee: 0,
    room_tip: 0,
    vat: 0,
    total_deductions: 0,
    cancel_amt: 0,
    normal_count: 0,
    cancel_count: 0,
    foreign_card_count: 0,
    foreign_card_amount: 0,
    domestic_card_count: 0,
    domestic_card_amount: 0,
    total_amount: 0,
  });

  const [hotelTotal, setHotelTotal] = useState<
    {
      hotel_name: string;
      total: TotalType;
    }[]
  >([]);
  // const [salesList, setSalesList] = useState<KnockStoreSettleType[]>([]);
  const [selectedList, setSelectedList] = useState<
    {
      created_at: string;
      hotel_name: string;
      store_name: string;
      bill_number: string;
      store_discount_amt: number;
      com_discount_amt: number;
      order_amount: number;
      delivery_price: number;
      final_payment_amt: number;
      payment_fee: number;
      relay_fee: number;
      room_tip: number;
      vat: number;
      total_deductions: number;
      issuer_name: string;
      pay_company: string;
      cancel_date: string;
      cancel_amt: number;
    }[]
  >([]);

  const selectRef = useRef<HTMLDivElement>(null);

  // API 호출
  const getStoreSettlement = async () => {
    try {
      const oData = {
        start_year: year,
        start_month: month,
        end_year: year,
        end_month: month,
      };

      const response = await SettlementController.getKnockStoreSettlementDetail({
        start_date: `${oData.start_year}-${oData.start_month}-01`,
        end_date: moment(`${oData.end_year}-${oData.end_month}`, 'YYYY-MM')
          .endOf('month')
          .format('YYYY-MM-DD'),
      });

      if (response && response.data) {
        console.log('getKnockStoreSettlement', response.data);
        if (response.data.ok) {
          setSelectedList(response.data.data);
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  const numberToUpper = (value: number) => {
    return String.fromCharCode(value + 65);
  };

  const excelDownloadClick = () => {
    if (selectedList) {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Sheet 1');

      worksheet.mergeCells('A1:K1');
      worksheet.getCell('A1').value = '노크노크 주문 내역';
      worksheet.mergeCells('A2:K2');

      const uploadedHeader = excelHeader;
      // const uploadedHeader = [...excelHeader.slice(0, 7), '', ...excelHeader.slice(7)];
      // console.log('uploadedHeader', uploadedHeader);
      const mainHeader = worksheet.addRow(uploadedHeader.slice(0, uploadedHeader.length));
      // worksheet.addRow(excelSubHeader.slice(0, excelSubHeader.length)););
      mainHeader.eachCell((cell: any) => {
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
      });
      // worksheet.getCell('H3').value = undefined;
      // worksheet.mergeCells('G3:H3');
      // worksheet.getCell('G4').value = '매장부담(B1)';
      // worksheet.getCell('H4').value = '노크노크부담(B2)';
      // uploadedHeader.map((cell: any, index: number) => {
      //   if (index !== 6 && index !== 7) {
      //     worksheet.mergeCells(`${numberToUpper(index)}3:${numberToUpper(index)}4`);
      //   }
      // });
      for (let i = 5; i <= 14; i++) {
        worksheet.getColumn(i).numFmt = '#,##0';
      }
      for (let i = 0; i < selectedList.length; i++) {
        const data = selectedList[i];
        worksheet.addRow([
          moment(data.created_at).format('YYYY-MM-DD HH:mm:ss'),
          data.hotel_name,
          data.store_name,
          data.bill_number,
          Number(data.store_discount_amt),
          Number(data.com_discount_amt),
          Number(data.order_amount),
          Number(data.delivery_price),
          Number(data.final_payment_amt),
          Number(data.payment_fee),
          Number(data.relay_fee),
          Number(data.room_tip),
          Number(data.vat),
          Number(data.total_deductions),
          data.issuer_name,
          data.pay_company,
          data.cancel_date ? moment(data.cancel_date).format('YYYY-MM-DD') : '',
        ]);
      }
      // 아래 총합계
      // const lastRowIndex = selectedList.data.length + 5;
      // worksheet.mergeCells('A' + lastRowIndex + ':K' + lastRowIndex);
      // worksheet.getCell('A' + lastRowIndex).value =
      //   '총 최종 정산 금액: ' + totalScheduledSettlementAmt.toLocaleString() + '원';
      // 엑셀 파일로 저장
      workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `노크노크 주문 상세내역.xlsx`);
        document.body.appendChild(link);
        link.click();
      });
    }
  };

  // getStoreSettlement
  useEffect(() => {
    getStoreSettlement();
  }, [year, month]);

  useEffect(() => {
    // getStoreSettlement();

    const handleClickOutside = (event: any) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setVisibleMonthSelect(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    getStoreSettlement();

    const handleClickOutside = (event: any) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setVisibleMonthSelect(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const totalData: TotalType = {
      store_discount_amt: 0,
      com_discount_amt: 0,
      order_amount: 0,
      delivery_price: 0,
      final_payment_amt: 0,
      payment_fee: 0,
      relay_fee: 0,
      room_tip: 0,
      vat: 0,
      total_deductions: 0,
      cancel_amt: 0,
      normal_count: 0,
      cancel_count: 0,
      foreign_card_count: 0,
      foreign_card_amount: 0,
      domestic_card_count: 0,
      domestic_card_amount: 0,
      total_amount: 0,
    };

    const hotelTotalData: Record<string, TotalType> = {};

    const cardData: Record<string, number> = {};

    for (const data of selectedList) {
      if (data.cancel_date) {
        totalData.cancel_amt = totalData.cancel_amt + data.cancel_amt;
        totalData.cancel_count = totalData.cancel_count + 1;
      } else {
        totalData.store_discount_amt = totalData.store_discount_amt + data.store_discount_amt;
        totalData.com_discount_amt = totalData.com_discount_amt + data.com_discount_amt;
        totalData.order_amount = totalData.order_amount + data.order_amount;
        totalData.delivery_price = totalData.delivery_price + data.delivery_price;
        totalData.final_payment_amt = totalData.final_payment_amt + data.final_payment_amt;
        totalData.payment_fee = totalData.payment_fee + data.payment_fee;
        totalData.relay_fee = totalData.relay_fee + data.relay_fee;
        totalData.room_tip = totalData.room_tip + data.room_tip;
        totalData.vat = totalData.vat + data.vat;
        totalData.total_deductions = totalData.total_deductions + data.total_deductions;
        totalData.normal_count = totalData.normal_count + 1;
      }

      if (data.issuer_name && data.issuer_name.includes('해외')) {
        totalData.foreign_card_count = totalData.foreign_card_count + 1;
        totalData.foreign_card_amount = totalData.foreign_card_amount + data.final_payment_amt;
      } else {
        totalData.domestic_card_count = totalData.domestic_card_count + 1;
        totalData.domestic_card_amount = totalData.domestic_card_amount + data.final_payment_amt;
      }

      totalData.total_amount = totalData.final_payment_amt;

      if (!cardData[data.issuer_name]) {
        cardData[data.issuer_name] = 1;
      } else {
        cardData[data.issuer_name] = cardData[data.issuer_name] + 1;
      }
    }

    for (const data of selectedList) {
      if (!hotelTotalData[data.hotel_name]) {
        hotelTotalData[data.hotel_name] = {
          store_discount_amt: 0,
          com_discount_amt: 0,
          order_amount: 0,
          delivery_price: 0,
          final_payment_amt: 0,
          payment_fee: 0,
          relay_fee: 0,
          room_tip: 0,
          vat: 0,
          total_deductions: 0,
          cancel_amt: 0,
          normal_count: 0,
          cancel_count: 0,
          foreign_card_count: 0,
          foreign_card_amount: 0,
          domestic_card_count: 0,
          domestic_card_amount: 0,
          total_amount: 0,
        };
      }

      if (data.cancel_date) {
        hotelTotalData[data.hotel_name].cancel_amt =
          hotelTotalData[data.hotel_name].cancel_amt + data.cancel_amt;
        hotelTotalData[data.hotel_name].cancel_count =
          hotelTotalData[data.hotel_name].cancel_count + 1;
      } else {
        hotelTotalData[data.hotel_name].store_discount_amt =
          hotelTotalData[data.hotel_name].store_discount_amt + data.store_discount_amt;
        hotelTotalData[data.hotel_name].com_discount_amt =
          hotelTotalData[data.hotel_name].com_discount_amt + data.com_discount_amt;
        hotelTotalData[data.hotel_name].order_amount =
          hotelTotalData[data.hotel_name].order_amount + data.order_amount;
        hotelTotalData[data.hotel_name].delivery_price =
          hotelTotalData[data.hotel_name].delivery_price + data.delivery_price;
        hotelTotalData[data.hotel_name].final_payment_amt =
          hotelTotalData[data.hotel_name].final_payment_amt + data.final_payment_amt;
        hotelTotalData[data.hotel_name].payment_fee =
          hotelTotalData[data.hotel_name].payment_fee + data.payment_fee;
        hotelTotalData[data.hotel_name].relay_fee =
          hotelTotalData[data.hotel_name].relay_fee + data.relay_fee;
        hotelTotalData[data.hotel_name].room_tip =
          hotelTotalData[data.hotel_name].room_tip + data.room_tip;
        hotelTotalData[data.hotel_name].vat = hotelTotalData[data.hotel_name].vat + data.vat;
        hotelTotalData[data.hotel_name].total_deductions =
          hotelTotalData[data.hotel_name].total_deductions + data.total_deductions;
        hotelTotalData[data.hotel_name].normal_count =
          hotelTotalData[data.hotel_name].normal_count + 1;
      }

      if (data.issuer_name && data.issuer_name.includes('해외')) {
        hotelTotalData[data.hotel_name].foreign_card_count =
          hotelTotalData[data.hotel_name].foreign_card_count + 1;
        hotelTotalData[data.hotel_name].foreign_card_amount =
          hotelTotalData[data.hotel_name].foreign_card_amount + data.final_payment_amt;
      } else {
        hotelTotalData[data.hotel_name].domestic_card_count =
          hotelTotalData[data.hotel_name].domestic_card_count + 1;
        hotelTotalData[data.hotel_name].domestic_card_amount =
          hotelTotalData[data.hotel_name].domestic_card_amount + data.final_payment_amt;
      }

      hotelTotalData[data.hotel_name].total_amount =
        hotelTotalData[data.hotel_name].final_payment_amt;
    }

    const cardList: { card_name: string; count: number }[] = [];
    for (const key in cardData) {
      cardList.push({
        card_name: key,
        count: cardData[key],
      });
    }

    const hotelList: { hotel_name: string; total: TotalType }[] = [];
    for (const key in hotelTotalData) {
      hotelList.push({
        hotel_name: key,
        total: hotelTotalData[key],
      });
    }

    cardList.sort((a, b) => b.count - a.count);
    hotelList.sort((a, b) => b.total.final_payment_amt - a.total.final_payment_amt);
    setHotelTotal(hotelList);
    setCard(cardList);
    setTotal(totalData);
  }, [selectedList]);

  // useEffect(() => {
  //   if (salesList.length > 0) {
  //     console.log('salesList', salesList);
  //   }
  // }, [salesList]);

  const excelHotelHeader = [
    '호텔이름',
    '전체 주문 건수',
    '주문 정산 건수',
    '정산 취소 건수',
    '국내카드 이용건수',
    '국내카드 결제금액',
    '해외카드 이용건수',
    '해외카드 결제금액',
    '주문금액',
    '매장부담할인',
    '본사부담할인',
    '배달팁',
    '최종결제금액',
    '결제수수료',
    '중개수수료',
    '객실관리팁',
    '부가세',
    '공제총액',
    '정산취소금액',
  ];

  //테이블 헤더
  const excelHeader = [
    '주문일시',
    '호텔명',
    '매장이름',
    '주문번호',
    '매장부담할인',
    '본사부담할인',
    '주문금액',
    '배달팁',
    '최종결제금액',
    '결제수수료',
    '중개수수료',
    '객실관리팁',
    '부가세',
    '공제총액',
    '발급사명',
    '결제사',
    '정산 취소일자',
  ];

  const excelSubHeader = ['매장부담(B1)', '노크노크부담(B2)'];

  const RenderMonthSelect = () => {
    const arrayItems = Array.from({ length: 12 }, (_, index) => index + 1);
    return (
      <div className={`selectBox ${!visibleMonthSelect && 'none'}`} ref={selectRef}>
        <div className="yearSelect">
          <button className="left" onClick={() => setYear(year - 1)} />
          {year}
          <button className="right" onClick={() => setYear(year + 1)} />
        </div>
        <div className="monthSelect">
          {arrayItems.map((item, index) => (
            <div
              key={index}
              className={`monthItem ${month === item && 'active'}`}
              onClick={() => setMonth(item)}>
              {item}월
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderLogic = () => {
    return (
      <table
        style={{
          border: '1px solid black',
          borderCollapse: 'collapse',
          width: '40%', // 표 너비를 50%로 설정
          textAlign: 'center',
          // margin: 'auto', // 가운데 정렬을 위한 자동 여백
        }}>
        <thead>
          <tr style={{ backgroundColor: '#f2f2f2' }}>
            <th colSpan={2} style={{ border: '1px solid black', padding: '4px' }}>
              설명
            </th>
            <th style={{ border: '1px solid black', padding: '4px' }}>수식</th>
            <th style={{ border: '1px solid black', padding: '4px' }}>비고</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ border: '1px solid black', padding: '4px' }}>A</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>주문금액</td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
          </tr>
          <tr>
            <td rowSpan={2} style={{ border: '1px solid black', padding: '4px' }}>
              B
            </td>
            <td style={{ border: '1px solid black', padding: '4px' }}>B1: 매장부담할인</td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '4px' }}>B2: 노크노크부담할인</td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '4px' }}>C</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>배달팁</td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '4px' }}>D</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>객실관리팀</td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '4px' }}>E</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>최종결제금액</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>A - B + C + D</td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '4px' }}>F</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>결제수수료</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>(E - D) * 0.03</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>
              F 소수점 버림 , 해외결제 수수료 0.04
            </td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '4px' }}>G</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>중개수수료</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>(E + B2 - C - D) * 0.068</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>G 소수점 버림</td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '4px' }}>H</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>부가세</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>(F * 0.1) + (G * 0.1)</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>H 소수점 버림</td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '4px' }}>I</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>공제총액</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>F + G + H</td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '4px' }}>J</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>정산 예정 금액</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>E - D + B2 - I</td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '4px' }}>K</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>취소 정산 금액</td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
          </tr>
          <tr>
            <td style={{ border: '1px solid black', padding: '4px' }}>L</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>전 정산의 미차감액</td>
            <td style={{ border: '1px solid black', padding: '4px' }}></td>
            <td style={{ border: '1px solid black', padding: '4px' }}>가장 최근 정산의 (N)</td>
          </tr>
          <tr style={{ backgroundColor: 'yellow' }}>
            <td style={{ border: '1px solid black', padding: '4px' }}>M</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>최종 정산 금액</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>J - (K + L)</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>{`J < K + L 인 경우 0`}</td>
          </tr>
          <tr style={{ backgroundColor: 'rgb(255, 200, 200)' }}>
            <td style={{ border: '1px solid black', padding: '4px' }}>N</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>미차감액</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>(K + L) - J</td>
            <td style={{ border: '1px solid black', padding: '4px' }}>{`K + L < J 인 경우 0`}</td>
          </tr>
        </tbody>
      </table>
    );
  };

  const renderHotelTableItem = () => {
    return (
      <>
        {hotelTotal.map((data, dataIndex: number) => (
          <tr className="webTableWrap">
            <td>{data.hotel_name}</td>
            <td>{data.total.normal_count + data.total.cancel_count}</td>
            <td>{data.total.normal_count}</td>
            <td>{data.total.cancel_count}</td>
            <td>{data.total.domestic_card_count}</td>
            <td>₩{Number(data.total.domestic_card_amount).toLocaleString()}</td>
            <td>{data.total.foreign_card_count}</td>
            <td>₩{Number(data.total.foreign_card_amount).toLocaleString()}</td>
            <td>₩{Number(data.total.order_amount).toLocaleString()}</td>
            <td>₩{Number(data.total.store_discount_amt).toLocaleString()}</td>
            <td>₩{Number(data.total.com_discount_amt).toLocaleString()}</td>
            <td>₩{Number(data.total.delivery_price).toLocaleString()}</td>
            <td>₩{Number(data.total.final_payment_amt).toLocaleString()}</td>
            <td>₩{Number(data.total.payment_fee).toLocaleString()}</td>
            <td>₩{Number(data.total.relay_fee).toLocaleString()}</td>
            <td>₩{Number(data.total.room_tip).toLocaleString()}</td>
            <td>₩{Number(data.total.vat).toLocaleString()}</td>
            <td>₩{Number(data.total.total_deductions).toLocaleString()}</td>
            <td>₩{Number(data.total.cancel_amt).toLocaleString()}</td>
          </tr>
        ))}
        {hotelTotal.length > 0 ? (
          <tr className="webTableWrap" style={{ background: 'yellow' }}>
            <td>합계</td>
            <td>{total.normal_count + total.cancel_count}</td>
            <td>{total.normal_count}</td>
            <td>{total.cancel_count}</td>
            <td>{total.domestic_card_count}</td>
            <td>₩{Number(total.domestic_card_amount).toLocaleString()}</td>
            <td>{total.foreign_card_count}</td>
            <td>₩{Number(total.foreign_card_amount).toLocaleString()}</td>
            <td>₩{Number(total.order_amount).toLocaleString()}</td>
            <td>₩{Number(total.store_discount_amt).toLocaleString()}</td>
            <td>₩{Number(total.com_discount_amt).toLocaleString()}</td>
            <td>₩{Number(total.delivery_price).toLocaleString()}</td>
            <td>₩{Number(total.final_payment_amt).toLocaleString()}</td>
            <td>₩{Number(total.payment_fee).toLocaleString()}</td>
            <td>₩{Number(total.relay_fee).toLocaleString()}</td>
            <td>₩{Number(total.room_tip).toLocaleString()}</td>
            <td>₩{Number(total.vat).toLocaleString()}</td>
            <td>₩{Number(total.total_deductions).toLocaleString()}</td>
            <td>₩{Number(total.cancel_amt).toLocaleString()}</td>
          </tr>
        ) : (
          <></>
        )}
      </>
    );
  };

  const renderTableItem = () => {
    return (
      <>
        {selectedList &&
          selectedList.map((data, dataIndex: number) => (
            <tr className="webTableWrap">
              <td>{moment(data.created_at).format('YYYY-MM-DD HH:mm:ss')}</td>
              <td>{data.hotel_name}</td>
              <td>{data.store_name}</td>
              <td>{data.bill_number}</td>
              <td>₩{Number(data.store_discount_amt).toLocaleString()}</td>
              <td>₩{Number(data.com_discount_amt).toLocaleString()}</td>
              <td>₩{Number(data.order_amount).toLocaleString()}</td>
              <td>₩{Number(data.delivery_price).toLocaleString()}</td>
              <td>₩{Number(data.final_payment_amt).toLocaleString()}</td>
              <td>₩{Number(data.payment_fee).toLocaleString()}</td>
              <td>₩{Number(data.relay_fee).toLocaleString()}</td>
              <td>₩{Number(data.room_tip).toLocaleString()}</td>
              <td>₩{Number(data.vat).toLocaleString()}</td>
              <td>₩{Number(data.total_deductions).toLocaleString()}</td>
              <td>{data.issuer_name}</td>
              <td>{data.pay_company}</td>
              <td>{data.cancel_date ? moment(data.cancel_date).format('YYYY-MM-DD') : ''}</td>
            </tr>
          ))}
      </>
    );
  };

  const renderCard = () => {
    return (
      <>
        {card.map((data) => (
          <div className="statusBox">
            <h5>{data.card_name !== 'null' ? data.card_name : '-'}</h5>
            <h4>{Number(data.count)}건</h4>
          </div>
        ))}
      </>
    );
  };

  return (
    <Style>
      <div className="rightContentWrap">
        <button className="backButton" onClick={() => navigate('/dashboard')}>
          <img src={`${process.env.PUBLIC_URL}/svg/ic_home.svg`} alt="뒤로가기버튼" />
        </button>
        <div className="listWrap">
          <div className="listItem" onClick={() => setVisibleMonthSelect(true)}>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_calendar.svg`} alt="calendar" />
            <h4>
              {year}년 {month}월
            </h4>
          </div>
          {/* <button onClick={getStoreSettlement}>
            <h4>조회</h4>
          </button> */}
          {visibleMonthSelect && <RenderMonthSelect />}

          <div className=""></div>
        </div>
        <h1>
          KNOCKKNOCK [{year}년 {month}월] 주문 정산
        </h1>
        <br />
        <h3>일정산 완료된건만 확인가능합니다</h3>
        <br />
        <br />
        <div className="statusWrap">
          <div className="statusBox">
            <h5>전체 주문 건수</h5>
            <h4>{total.normal_count + total.cancel_count}건</h4>
          </div>
          <div className="statusBox">
            <h5>주문 정산 건수</h5>
            <h4>{total.normal_count}건</h4>
          </div>
          <div className="statusBox">
            <h5>정산 취소 건수</h5>
            <h4>{total.cancel_count}건</h4>
          </div>
        </div>
        <div className="statusWrap">
          <div className="statusBox">
            <h5>국내카드 이용 건수</h5>
            <h5>(정산취소 포함)</h5>
            <h4>{total.domestic_card_count}건</h4>
          </div>
          <div className="statusBox">
            <h5>국내카드 결제 금액</h5>
            <h5>(정산취소 포함)</h5>
            <h4>₩{Number(total.domestic_card_amount).toLocaleString()}원</h4>
          </div>
          <div className="statusBox">
            <h5>해외카드 이용 건수</h5>
            <h5>(정산취소 포함)</h5>
            <h4>{total.foreign_card_count}건</h4>
          </div>
          <div className="statusBox">
            <h5>해외카드 결제 금액</h5>
            <h5>(정산취소 포함)</h5>
            <h4>₩{Number(total.foreign_card_amount).toLocaleString()}원</h4>
          </div>
        </div>
        <div className="statusWrap">
          <div className="statusBox">
            <h5>주문건당 평균결제금액</h5>
            <h5>(정산취소 포함)</h5>
            <h4>
              ₩
              {total.normal_count + total.cancel_count > 0
                ? Number(
                    Math.floor(total.total_amount / (total.normal_count + total.cancel_count)),
                  ).toLocaleString()
                : 0}
              원
            </h4>
          </div>
        </div>
        <div className="statusWrap">
          <div className="statusBox">
            <h5>주문금액</h5>
            <h5>(정산취소 미포함)</h5>
            <h4>₩{Number(total.order_amount).toLocaleString()}원</h4>
          </div>
          <div className="statusBox">
            <h5>매장부담할인</h5>
            <h5>(정산취소 미포함)</h5>
            <h4>₩{Number(total.store_discount_amt).toLocaleString()}원</h4>
          </div>
          <div className="statusBox">
            <h5>본사부담할인</h5>
            <h5>(정산취소 미포함)</h5>
            <h4>₩{Number(total.com_discount_amt).toLocaleString()}원</h4>
          </div>
          <div className="statusBox">
            <h5>배달팁</h5>
            <h5>(정산취소 미포함)</h5>
            <h4>₩{Number(total.delivery_price).toLocaleString()}원</h4>
          </div>
          <div className="statusBox">
            <h5>최종결제금액</h5>
            <h5>(정산취소 미포함)</h5>
            <h4>₩{Number(total.final_payment_amt).toLocaleString()}원</h4>
          </div>
          <div className="statusBox">
            <h5>결제수수료</h5>
            <h5>(정산취소 미포함)</h5>
            <h4>₩{Number(total.payment_fee).toLocaleString()}원</h4>
          </div>
          <div className="statusBox">
            <h5>중개수수료</h5>
            <h5>(정산취소 미포함)</h5>
            <h4>₩{Number(total.relay_fee).toLocaleString()}원</h4>
          </div>
          <div className="statusBox">
            <h5>객실관리팁</h5>
            <h5>(정산취소 미포함)</h5>
            <h4>₩{Number(total.room_tip).toLocaleString()}원</h4>
          </div>
          <div className="statusBox">
            <h5>부가세</h5>
            <h5>(정산취소 미포함)</h5>
            <h4>₩{Number(total.vat).toLocaleString()}원</h4>
          </div>
          <div className="statusBox">
            <h5>공제총액</h5>
            <h5>(정산취소 미포함)</h5>
            <h4>₩{Number(total.total_deductions).toLocaleString()}원</h4>
          </div>
          <div className="statusBox">
            <h5>정산취소금액</h5>
            <h5>.</h5>
            <h4>₩{Number(total.cancel_amt).toLocaleString()}원</h4>
          </div>
        </div>
        {/* <div className="statusWrap">{renderCard()}</div> */}
        {/* <div className="listWrap">
          {/* <img
            src={`https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock.ivid.kr/settlelogic.png`}
            alt="calendar"
          /> */}
        {/* {renderLogic()} */}
        {/* </div>  */}

        <br />
        <br />
        <br />
        <h1>
          KNOCKKNOCK [{year}년 {month}월] 호텔 통계
        </h1>
        <br />
        <h3>최종결제금액 순</h3>
        <br />
        <CustomTable
          tableHeader={excelHotelHeader}
          // subHeader={excelSubHeader}
          renderTableItem={renderHotelTableItem}
          type="border"
        />
        <br />
        <br />
        <br />
        <h1>
          KNOCKKNOCK [{year}년 {month}월] 주문 내역
        </h1>
        <br />
        <div className="listWrap">
          {/* {salesList.map((item, index) => (
            <div key={index} className="listItem week" onClick={() => setSelectedList(item)}>
              <h4>{item.key}</h4>
            </div>
          ))} */}
          <button onClick={excelDownloadClick}>
            <h4>액셀 저장</h4>
          </button>
        </div>
        <CustomTable
          tableHeader={excelHeader}
          // subHeader={excelSubHeader}
          renderTableItem={renderTableItem}
          type="border"
        />
      </div>
    </Style>
  );
};

export default KnockStoreOrderSettle;

const Style = styled.div`
  .statusWrap {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
    padding-bottom: 20px;

    .statusBox {
      width: 170px;
      border-radius: 5px;
      border: 1px solid #cecece;
      background: #fcfcfc;
      padding: 4px 20px;

      h5 {
        font-weight: 400;
      }
      h4 {
        padding-top: 6px;
        font-weight: 700;
      }
    }
  }

  .rightContentWrap {
    width: 100%;
    height: 100vh;
    background: #ffffff;
    padding: 2% 4%;
  }

  .listWrap {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    margin: 10px 0;
    position: relative;

    .listItem {
      min-width: 160px;
    }

    .selectBox {
      width: 240px;
      top: 46px;
      position: absolute;
      background: #ffffff;
      border-radius: 5px;
      z-index: 1;

      .yearSelect {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 6px 8px;
        border-radius: 5px 5px 0 0;
        border: 1px solid #dedede;
        border-bottom: none;
        button {
          padding: 0;
          background: none;
        }
        button.left {
          border-top: 8px solid transparent;
          border-bottom: 8px solid transparent;
          border-right: 12px solid #333333;
        }
        button.right {
          border-top: 8px solid transparent;
          border-bottom: 8px solid transparent;
          border-left: 12px solid #333333;
        }
      }
      .monthSelect {
        display: flex;
        flex-wrap: wrap;
        border-top: none;
        .monthItem {
          width: 80px;
          padding: 4px;
          border: 1px solid #dedede;
          text-align: center;
          cursor: pointer;
        }
        .monthItem.active {
          background: #4dd2ae;
          color: #ffffff;
        }
        .monthItem:nth-child(10) {
          border-radius: 0 0 0 5px;
        }
        .monthItem:nth-child(12) {
          border-radius: 0 0 5px 0;
        }
      }
    }

    .selectBox:before {
      content: '';
      position: absolute;
      left: 20px;
      top: -9px;
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-bottom: 10px solid #dedede;
    }
    .selectBox:after {
      content: '';
      position: absolute;
      left: 21px;
      top: -7px;
      width: 0;
      height: 0;
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-bottom: 8px solid #ffffff;
    }

    .listItem {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 6px 16px;
      border: 2px solid #cecece;
      border-radius: 5px;
      cursor: pointer;
      h4 {
        color: #333333;
        font-weight: 500;
      }
    }
    .listItem:hover {
      border-color: #40977f;
    }
    .listItem.week:hover {
      h4 {
        color: #40977f;
      }
    }
    button {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 8px 20px;
      border-radius: 5px;
      border: none;
      background: #40977f;
      h4 {
        font-weight: 600;
        color: #ffffff;
      }
    }
    button:hover {
      background: #4dd2ae;
    }
  }

  /* table */
  .normalTable thead tr {
    font-size: 14px;
    white-space: nowrap;
  }
  .normalTable tbody td {
    font-size: 14px;
    padding: 8px 10px;
    font-weight: 500;
    white-space: nowrap;

    img {
      width: 16px;
      cursor: pointer;
    }
  }
`;
